export const DEVICE_OBSERVER_NAME = 'device';
export const RESIZE_OBSERVER_NAME = 'resize';
export const DEBOUNCE_WAIT = 100;
